export class Page {
    id: number;
    title: string;
    page_text: string;
    is_published: boolean;
}
